<ap-findcontrol-advanced
  class="fc-advanced-flex"
  [baseId]="baseId"
  [findControlId]="findControlId"
  [requiredSearchParameters]="requiredSearchParameters"
  [additionalSearchParameters]="additionalSearchParameters"
  [mode]="mode"
  [updateObs]="updateObs"
  [undoComponentId]="undoComponentId"
  (deleteClick)="onDelete($event)"
  (finishLoad)="onFindControlLoaded($event)"
  (modifyClick)="onModify($event)"
  (newClick)="onNewClick()"
></ap-findcontrol-advanced>
